/*
 * Copyright (c) Nexign, JSC, 2020.
 */

/**
 * The constants for Guard module
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.0.0
 */

/*
* -------------------------------------------
*        CHECK GUARD (ALL PERMISSIONS)
* -------------------------------------------
*/

export const CHECK_GUARD = '@@b2b_portal_ui/guard/CHECK_GUARD';
export const CHECK_GUARD_ERROR = '@@b2b_portal_ui/guard/CHECK_GUARD_ERROR';
export const CHECK_GUARD_SUCCESSFUL = '@@b2b_portal_ui/guard/CHECK_GUARD_SUCCESSFUL';

export const SET_GUARD_COMPONENT_KEY = '@@b2b_portal_ui/guard/SET_GUARD_COMPONENT_KEY';
